/* Currency */
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY'

/* language */
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const LANGUAGES_LIST = ['en', 'es']

/* user */
export const FETCH_USER = 'FETCH_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const LOY3_REGISTER_SUCCESS = 'LOY3_REGISTER_SUCCESS'


/* catalogue */
export const FETCH_CATALOGUE_PAGE = 'FETCH_CATALOGUE_PAGE';
export const GET_LOY3_CATALOGUE_HOTELS = 'LOY3_GET_HOTELS';
export const CHANGE_CATALOGUE_PAGE = 'CHANGE_CATALOGUE_PAGE';

/* modals */
export const SET_MODAL = 'SET_MODAL';

/* sandos4U */
export const LOGIN_SANDOS4U = 'LOGIN_SANDOS4U'
export const FETCH_SANDOS4U = 'FETCH_SANDOS4U'
export const REGISTER_SANDOS4U = 'REGISTER_SANDOS4U'
export const LOY3_GET_TRANSACTIONS_SUCCESS = 'LOY3_GET_TRANSACTIONS_SUCCESS'
export const LOY3_CLEAR_TRANSACTIONS = 'LOY3_CLEAR_TRANSACTIONS'

/* userProfile */
export const SAVE_OR_UPDATE_USER = 'SAVE_OR_UPDATE_USER'

/* form booking */
export const TOOGLE_BOOKING_FORM = 'TOOGLE_BOOKING_FORM'
export const SHOW_BOOKING_FORM = 'SHOW_BOOKING_FORM'
export const VIEW_MORE_RESERVE_BOOKING = 'VIEW_MORE_RESERVE_BOOKING'
export const VIEW_MORE_CHECKIN_BOOKING = 'VIEW_MORE_CHECKIN_BOOKING'
export const VIEW_MORE_CHECKOUT_BOOKING = 'VIEW_MORE_CHECKOUT_BOOKING'
export const VIEW_MORE_CLAIMED_BOOKING = 'VIEW_MORE_CLAIMED_BOOKING'

/* loading */
export const START_LOADING = 'START_LOADING'
export const FINISH_LOADING = 'FINISH_LOADING'


/* Cart */
export const ADD_ITEM_CART = 'ADD_ITEM_CART'
export const ADD_ITEM_CART_SUCCESS = 'ADD_ITEM_CART_SUCCESS';
export const DELETE_ITEM_CART = 'DELETE_ITEM_CART'
export const CLEAN_CART = 'CLEAN_CART'


/* titleId in nav */
export const SET_TITLE_ID = 'SET_TITLE_ID'

/* hero banner */
export const HERO_BANNER = 'HERO_BANNER';
